import type { HomepageContent } from '../../cms/homepage'
import HomepageActionLink from './HomepageActionLink'
import HomepageSectionHeader from './HomepageSectionHeader'

type MapPreviewSectionProps = {
  content: HomepageContent['mapExplore']
  latestDiscoveryTitle?: string
}

export default function MapPreviewSection({
  content,
  latestDiscoveryTitle,
}: MapPreviewSectionProps) {
  return (
    <section className="home-section home-anchor-target" id="how-it-works">
      <HomepageSectionHeader title={content.title} />
      <article className="home-map-preview">
        <HomepageActionLink className="home-map-stage" href={content.ctaHref}>
          <p className="home-map-stage-label">Places in Time map preview</p>
          <div className="home-map-canvas-preview" aria-label="Preview of the Time Map">
            <img
              className="home-map-thumb"
              src="/images/home/map_thumb.png"
              alt="Preview of the Places in Time Time Map"
              loading="lazy"
              decoding="async"
            />
            {latestDiscoveryTitle && (
              <div className="home-map-discovery-callout">
                <p className="home-map-discovery-label">Live archaeology</p>
                <p className="home-map-discovery-title">{latestDiscoveryTitle}</p>
              </div>
            )}
          </div>
        </HomepageActionLink>
        <div className="home-map-copy">
          <p className="home-map-copy-intro">{content.intro}</p>
          {content.layers.map((layer) => (
            <article key={layer.label} className="home-map-thread">
              <h3>{layer.label}</h3>
              <p>{layer.body}</p>
            </article>
          ))}
          <div className="home-section-actions">
            <HomepageActionLink className="button primary" href={content.ctaHref}>
              {content.ctaLabel}
            </HomepageActionLink>
          </div>
        </div>
      </article>
    </section>
  )
}
